import { useMemo } from "react";
import { useGetDepositsQuery } from "@/queries/useGetDepositsQuery";

interface DepositItem {
  id: string;
  name: string;
  balance: number;
}

export const useDeposits = () => {
  const { data, isLoading, isError } = useGetDepositsQuery();
  const depositsData = (data || []) as DepositItem[];

  const primaryDeposit = useMemo(() => {
    if (depositsData.length === 0) return null;
    const top = depositsData.reduce((prev, current) =>
      current.balance > prev.balance ? current : prev
    );
    return { ...top, formattedBalance: top.balance.toLocaleString("ru-RU") };
  }, [depositsData]);

  return {
    depositsData,
    primaryDeposit,
    isLoading,
    isError,
    hasDeposits: depositsData.length > 0,
  };
};
